import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { FooterComponent } from '../components/footer/footer.component';
import { TopnavbarComponent } from '../components/topnavbar/topnavbar.component';

@Component({
  standalone: true,
  selector: 'app-listings-layout',
  templateUrl: './listings-layout.component.html',
  styleUrls: ['./listings-layout.component.scss'],
  imports: [RouterOutlet, NzLayoutModule, TopnavbarComponent, FooterComponent],
})
export class ListingsLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
